<template>
    <div v-if="attachments.length" class="pt-8 md:pt-12 grid grid-cols-4 gap-5">
        <div class="col-span-4 title title-md mb-2">{{ $t('generic.downloadables') }}</div>

        <a
            v-for="(attachment, i) in attachments"
            :key="i"
            :href="attachment.url"
            target="_blank"
            rel="noopener noreferrer"
            class="col-span-4 sm:col-span-2 p-4 bg-gray-100 rounded desktop:hover:bg-gray-150 flex items-center"
            :download="attachment.filename"
            :title="attachment.filename"
        >
            <i class="pi pi-file text-lg mr-2"></i>
            <span class="overflow-hidden overflow-ellipsis whitespace-nowrap relative">{{ attachment.filename }}</span>
        </a>
    </div>
</template>

<script>
export default {
    name: 'SectionDownloadables',
    props: {
        attachments: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped></style>
